export default __webpack_public_path__ + "static/media/MRamzan_v10.1aec43cf.pdf";